import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ComponentTheme,
  DebugService,
  DebugServiceToken,
  ModalService,
  ResponsiveService,
  SimpleModalConfig,
} from '@frk/eds-components';
import { ModalId } from '@products/base-product-detail.component';
import { ProductDetailService } from '@products/product-detail-layout/product-detail.service';
import { AppStateService } from '@services';
import {
  FundSummaryCalcTypeVisibility,
  FundSummaryData,
  ProductDetailConfiguration,
} from '@types';
import { Logger } from '@utils/logger';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const logger = Logger.getLogger('SummaryUSComponent');

@Component({
  selector: 'ft-summary-us',
  templateUrl: './summary-us.component.html',
  styleUrls: ['./summary-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryUSComponent implements AfterViewInit, OnDestroy, OnInit {
  @Input() brConfig: ProductDetailConfiguration;
  @Input() fundSummaryInfo: FundSummaryData;
  @Input() calcTypeVisibility: FundSummaryCalcTypeVisibility;
  @Input() showRatings: boolean;

  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;

  public ModalId = ModalId;

  public componentTheme: ComponentTheme;
  public hideVIPData = false;

  private unsubscribe$: Subject<void> = new Subject<void>();

  /**
   * Expand All Components for Audit - flag
   */
  private isExpandAll = false;

  constructor(
    private modalService: ModalService,
    private productDetailService: ProductDetailService,
    private appStateService: AppStateService,
    private responsiveService: ResponsiveService,
    @Inject(DebugServiceToken) private debugService?: DebugService
  ) {
    this.isHandheld$ = this.responsiveService.isHandheld$();
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  ngAfterViewInit(): void {
    /**
     * Expand All Components for Audit - implementation
     */
    this.debugService
      .getExpandAllComponents$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((expandAll: boolean) => {
        if (expandAll) {
          this.isExpandAll = true;
          this.viewDetails();
        }
      });
  }

  ngOnInit(): void {
    this.componentTheme = this.appStateService.getFundHeaderTheme();
    this.productDetailService.isVIPNonLoggedIn$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((status) => {
        this.hideVIPData = status;
      });
    logger.debug('fundSummaryInfo', this.fundSummaryInfo);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public viewDetails() {
    const config: SimpleModalConfig = {
      modalId: ModalId.Morningstar_Modal,
      type: 'simple',
      eventName: 'morningstar details',
      eventAction: 'Click',
      isEmbeddedInPage: this.isExpandAll,
    };
    this.modalService.open(ModalId.Morningstar_Modal, config);
  }
}
